import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class OpponentExposureValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking, players} = this.dependencies;
        const items = stacking.getItems();

        for (let item of Object.values(items)) {
            // @ts-ignore
            const stackExp = item.getExposure();
            // @ts-ignore
            const opponentIds = item.getOpponentIds();

            for (let opponentId of opponentIds) {
                const opponent = players.getPlayer(opponentId);
                const opponentExpMax = this.calcTotalExposureMaxOfOpponent(opponent);

                if (opponentExpMax < stackExp) {
                    this.addError(
                        `The max exposure limit on player ${opponent.name} is too low to comply with the requested stack exposure.`,
                    );
                    return;
                }
            }
        }
    }

    private calcTotalExposureMaxOfOpponent(opponent): number {
        // @ts-ignore
        const {modes} = this.dependencies;
        let opponentExpMax = 0;
        modes.map((mode) => {
            if (!opponent.isExcludedByMode(mode)) {
                opponentExpMax += 1 * opponent.getPropValueOfMode('exposureMax', mode);
            }
        });

        return opponentExpMax;
    }
}

export default OpponentExposureValidator;
